import { Constants, CYBER_CONSTANT } from 'constants';
import request from 'superagent';
import { format } from 'date-fns';
import Cookies from 'js-cookie';
import Pptxgen from 'pptxgenjs';
import ConfigPath from 'configpath';
import moment from 'moment/moment';
import React from 'react';

const getCookie = (cname) => {
  const name = `${cname}=`;
  const cookieList = document.cookie.split(';');
  for (let i = 0; i < cookieList.length; i += 1) {
    const cookieItem = cookieList[i]?.trim();
    if (cookieItem.indexOf(name) === 0) {
      return cookieItem.split('=')[1];
    }
  }
  return '';
};

const deleteCookie = (name) => {
  document.cookie = `${name
  }=; expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=.gartner.com; path=/; `;
};

export const getAuthorizationToken = (name) => {
  const domain = window.location.host;
  if (domain.indexOf(ConfigPath.APP_LOCAL_PATH) !== -1) {
    return getCookie(name);
  }
  return localStorage.getItem(name);
};

export const deleteAuthorizationToken = (name) => {
  const domain = window.location.host;
  if (domain.indexOf(ConfigPath.APP_LOCAL_PATH) !== -1) {
    return deleteCookie(name);
  }
  return localStorage.removeItem(name);
};

/**
 * Global funciton to log user out
 */
const HOST_URL = ConfigPath.TOOLS_URL;
export const LogOut = (allowPath = false) => {
  let domain; let
    port;
  if (window.location.hostname === Constants.URLs.DEVELOPER) {
    domain = ConfigPath.TOOLS_URL;
    port = `:${window.location.port}`;
  } else {
    domain = HOST_URL;
  }
  const logoffUrl = ConfigPath.GARTNER_URL + Constants.URLs.LOGOFF;
  const path = allowPath
    ? window.location.href
    : (`${window.location.protocol}//${window.location.hostname}${port || ''}${window.location.pathname}`);
  let redirectToLogin = `${domain + Constants.URLs.LOGON}?TARGET=${encodeURI(path)}`;
  if (redirectToLogin.includes(Constants.LABELS.CYBER)) {
    redirectToLogin = `${domain + Constants.URLs.LOGON}?${ConfigPath.GENIE_AUTH_PARAMS_CSVB}&TARGET=${encodeURI(path)}`;
  }
  if (redirectToLogin.includes(Constants.URLs.RAPID)) {
    redirectToLogin = `${domain + Constants.URLs.LOGON}?${ConfigPath.GENIE_AUTH_PARAMS_DES}&TARGET=${encodeURI(path)}`;
  }
  const token = getAuthorizationToken(ConfigPath.TOKEN_KEY_INFO);
  const headers = {
    Accept: 'application/json',
    Authorization: token ? `Bearer ${token}` : '',
  };
  request
    .post(logoffUrl)
    .withCredentials()
    .set(headers)
    .type('form')
    .end(() => {
      deleteAuthorizationToken(ConfigPath.TOKEN_KEY_INFO);
      localStorage.setItem('logout-event', true);
      window.location.assign(redirectToLogin);
    });
};

const compareScore = (lowerMargin, upperMargin, restMargin, score) => {
  let result;
  if (score < lowerMargin) {
    result = 0.25;
  } if (score < restMargin && score >= lowerMargin) {
    result = 0.5;
  } if (score >= restMargin && score < upperMargin) {
    result = 0.75;
  } if (score >= upperMargin) {
    result = 1;
  }
  return result;
};

export const calculateMethod = (KpiInfo) => {
  let sum = 0;
  Object.keys(Constants.KPIs).forEach((key) => {
    const { lowerMargin, upperMargin, restMargin } = Constants.KPIs[key];
    sum += compareScore(lowerMargin, upperMargin, restMargin, KpiInfo[key]?.value);
  });
  return (sum * 20);
};

export const debounce = (func, delay) => {
  let debounceTimer;
  return function timeout(...args) {
    const context = this;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => func.apply(context, args), delay);
  };
};

export const capitalize = (s) => {
  const value = s && s[0].toLowerCase() + s.slice(1);
  return value;
};

export const isEmptyValue = (val) => (val !== undefined && val !== '');

export const getDisplayValue = (val, fallbackVal, unit = '') => {
  if (!isEmptyValue(
    val,
  )) {
    return isEmptyValue(fallbackVal)
      ? CYBER_CONSTANT.LABEL.NOT_AVAILABLE
      : '';
  }
  return `${parseFloat(Number(val)?.toFixed(1))} ${
    unit
  }`;
};

export const getSelectionWithValuesAtIndex = (values = {}, index = 0) => Object
  .keys(values).filter((item) => values[item].length > 0)[index];

export const inputValue = (val, kpiValue, keyValue, unit, key) => {
  let returnVal;
  if (key === keyValue) {
    if (unit === '%') {
      if (val > 100) {
        returnVal = 100;
      } else if (val < 0) {
        returnVal = 0;
      } else {
        returnVal = val;
      }
    } else {
      returnVal = (val < 0) ? 0 : val;
    }
  } else {
    returnVal = kpiValue;
  }
  return returnVal?.toString();
};

export function keyDownA11y(handler) {
  return function onKeyDown(event) {
    if (
      ['keydown', 'keypress'].includes(event?.type)
      && ['Enter'].includes(event?.key)
    ) {
      if (handler) {
        handler();
      }
    }
  };
}

export const autoLogout = () => {
  localStorage.setItem('logout-event', false);
  window.addEventListener('storage', (event) => {
    if (event.key === 'logout-event' && event.newValue === 'true') {
      LogOut(true);
    }
  });
};

export const valueObject = (arr, val) => {
  if (val) {
    return arr.filter((item) => item.desc === val)[0];
  }
  return { desc: null };
};

export const objValueExist = (obj) => (Object.keys(obj).some((item) => (obj[item].desc === null)));

export const getStateFromPercentile = (percentile) => {
  if (percentile || percentile === 0) {
    if (percentile < 25) {
      return CYBER_CONSTANT.STATES.LAGGING;
    } if (percentile < 45) {
      return CYBER_CONSTANT.STATES.MID_LAGGING;
    } if (percentile < 55) {
      return CYBER_CONSTANT.STATES.MID_RANGE;
    } if (percentile < 75) {
      return CYBER_CONSTANT.STATES.MID_LEADING;
    }
    return CYBER_CONSTANT.STATES.LEADING;
  }
  return CYBER_CONSTANT.STATES.NOT_ANSWERED;
};

export const roundTo10th = (number) => {
  if (!number && number !== 0) {
    return '';
  }
  const value = typeof number === 'number' ? number : +number;
  return Math.round(value * 10) / 10;
};

export const getDisplayDate = (date, formatString = 'MMM yyyy') => format(date || new Date(), formatString);

export const ordinalSuffixOf = (i) => {
  const j = i % 10;
  const k = i % 100;
  if (j === 1 && k !== 11) { return 'st'; }
  if (j === 2 && k !== 12) { return 'nd'; }
  if (j === 3 && k !== 13) { return 'rd'; }
  return 'th';
};

export const drawerCategory = (index, kpiData, checkKpiData) => {
  let category = 'Action';
  if ((isEmptyValue(kpiData[index]?.curValue?.toString())
    && isEmptyValue(checkKpiData[index]?.curValue?.toString())
    && kpiData[index]?.curValue?.toString() !== checkKpiData[index]?.curValue?.toString())
    || (isEmptyValue(kpiData[index]?.tarValue?.toString())
    && isEmptyValue(checkKpiData[index]?.tarValue?.toString())
    && kpiData[index]?.tarValue?.toString() !== checkKpiData[index]?.tarValue?.toString())) {
    category = 'Action_Updated';
  } else if ((!isEmptyValue(kpiData[index]?.curValue?.toString())
    && isEmptyValue(checkKpiData[index]?.curValue?.toString())
    && kpiData[index]?.curValue?.toString() !== checkKpiData[index]?.curValue?.toString())
    || (!isEmptyValue(kpiData[index].tarValue?.toString())
    && isEmptyValue(checkKpiData[index].tarValue?.toString())
    && kpiData[index]?.tarValue?.toString() !== checkKpiData[index]?.tarValue?.toString())) {
    category = 'Action_Deleted';
  }
  return category;
};

export const checkIsFromConferenceApp = () => !!Cookies.get('mobileApp');

export const formatSeconds = (seconds) => `${Math.floor(seconds / 60)}:${(`0${Math.floor(seconds % 60)}`).slice(-2)}`;

export const isWhiteListUser = (roles, appName) => {
  if (roles?.filter(((role) => appName.includes(role)))) {
    return true;
  }
  return false;
};

export const waitFor = (time) => new Promise((resolve) => {
  setTimeout(() => resolve(), time);
});

export const pptxToFile = (b64Data, exportName) => {
  const contentType = 'application/vnd.openxmlformats-officedocument.presentationml.presentation';
  const sliceSize = 512;
  const byteCharacters = atob(b64Data);
  const byteArrays = [];
  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i += 1) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }
  const blob = new Blob(byteArrays, { type: contentType });
  const url = URL.createObjectURL(blob);

  const eleLink = document.createElement('a');
  eleLink.setAttribute('style', 'display:none;');
  eleLink.dataset.interception = 'off';
  document.body.appendChild(eleLink);

  if (window.URL.createObjectURL) {
    eleLink.href = url;
    eleLink.download = exportName;
    eleLink.click();
    setTimeout(() => {
      window.URL.revokeObjectURL(url);
      document.body.removeChild(eleLink);
    }, 100);
  }
};

export const runBrowserPPTXGen = async ({ metadata = {}, slides = [], masterSlides = [] } = {}) => {
  const pres = new Pptxgen();

  pres.defineLayout({ name: 'A3', width: 13.334, height: 7.5 });
  const {
    author = 'Gartner', company = 'Gartner', revision = 1, subject = 'Gartner', title = 'Gartner', layout = 'LAYOUT_16x9',
  } = metadata;
  pres.author = author;
  pres.company = company;
  pres.revision = revision;
  pres.subject = subject;
  pres.title = title;
  pres.layout = layout;

  masterSlides.forEach((masterSlide) => {
    pres.defineSlideMaster(masterSlide);
  });

  slides.forEach((_slide) => {
    const slide = pres.addSlide({ masterName: _slide.name });
    if (_slide.notes) {
      slide.addNotes(_slide.notes);
    }
    const components = _slide.components || [];
    components.forEach((component) => {
      if (component.type === 'image') {
        slide.addImage(component.props);
      } else if (component.type === 'text') {
        slide.addText(component.content, component.props);
      } else if (component.type === 'shape') {
        slide.addText(component.shape, component.props);
      } else if (component.type === 'table') {
        slide.addTable(component.rows, component.props);
      } else if (component.type === 'chart') {
        slide.addChart(component.chartType, component.chartData, component.props);
      }
    });
  });
  const pptxData = await pres.write('base64');
  return pptxData;
};

export const convertToLastDate = (date) => {
  if (date) {
    return (moment(date).format(CYBER_CONSTANT.DD_DATE_FORMAT));
  }
  return null;
};

export const trimText = (text, limit) => {
  if (text?.length <= limit) {
    return text;
  }
  return `${text?.substring(0, limit)}...`;
};

export const getStringWithBoldFormatting = (text = '') => {
  const regex = /<b>(.*?)<\/b>/g;
  const parts = text.split(regex);
  return (
    React.createElement('span', null, parts.map((part, index) => (index % 2 === 0 ? (
      part
    ) : (
      React.createElement('span', { style: { fontWeight: 500 }, key: part }, part)
    ))))
  );
};

export const isValidEmail = (email) => /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*(?:\.[a-zA-Z]{2,})$/.test(
  email,
);

export const isBusinessEmail = (email) => {
  const nonAllowedDomains = ['aol.com', 'att.net', 'comcast.net', 'facebook.com', 'gmail.com', 'gmx.com', 'hotmail.com', 'hotmail.co.uk', 'mac.com', 'me.com', 'icloud.com', 'mail.com', 'msn.com', 'live.com', 'sbcglobal.net', 'verizon.net', 'yahoo.com', 'yahoo.co.uk', 'email.com', 'games.com', 'gmx.net', 'hush.com', 'hushmail.com', 'inbox.com', 'lavabit.com', 'love.com', 'pobox.com', 'rocketmail.com', 'zoho.com', 'bellsouth.net', 'charter.net', 'cox.net', 'earthlink.net', 'juno.com', 'sharklasers.com', 'grr.la', 'guerillamail.biz', 'guerillamail.com', 'guerillamail.org', 'guerillamail.de', 'guerillamail.net', 'guerillamailblock.com', 'spam4.me', 'throam.com', 'mailinator.com', 'trbvm.com', 'lastmail.co', 'pwrby.com', 'yopmail.com', 'fakeinbox.com', 'rhyta.com', 'cuvox.de', 'dayrep.com', 'einrot.com', 'fleckens.hu', 'gustr.com', 'jourrapide.com', 'superrito.com', 'teleworm.us', 'outlook.com', 'inbox.com', 'yandex.com', 'aim.com', 'myway.com', 'optonline.net', 'forrester.com'];
  return isValidEmail(email) && !nonAllowedDomains.includes(email?.split('@')?.[1]);
};

export const isSameArray = (array1, array2) => ((array1.length === array2.length)
  && array1.every((element, index) => element === array2[index]));

export const countOccurrences = (arr) => {
  const custFreq = arr.reduce((acc, curr) => {
    acc[curr] = (acc[curr] ?? 0) + 1;
    return acc;
  }, {});
  return custFreq;
};
